import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useMedia } from 'sb-hooks'
import { intlMessageShape } from 'sb-react-intl'

import Message from 'components/text/Message/Message'
import CircleLoader from 'components/loaders/CircleLoader/CircleLoader'

import s from './Row.scss'


const BillRow = (props) => {
  const { isMobile } = useMedia()

  const { children, id, label, note, value, brand, isFetching } = props

  if (children) {
    return (
      <div className={s.item} id={id}>
        {children}
      </div>
    )
  }

  // TODO this is ductape
  // the value must be both white-space: wrap and nowrap
  // `wrap` for long test
  // `nowrap` for price `- $30` bcs if label is too long `-` and `$30` on different lines
  // so we need to check if value is price value then replace `space` with `&nbsp;` to prevent from wrapping
  // BEST WAY: add &nbsp; to formatPrice() but then we need to render result as node, not like string...
  const _value   = /^-\s\$[\d.]+$/.test(value) ? value.replace(' ', '&nbsp;') : value
  const withNote = Boolean(note)

  return (
    <div className={s.item} id={id}>
      <div className={s.content}>
        <div className={s.leftPart}>
          <Message
            className={s.label}
            tag="div"
            text={label}
            html
            name="paymentNew/Bill/Row/label"
            dataTestId="billRowTitle"
          />
          {
            !isFetching && withNote && (
              <Message className={s.note} text={note} dataTestId="billRowNote" />
            )
          }
        </div>
        {
          isFetching ? (
            <CircleLoader />
          ) : (
            <div className={cx(s.value, { [s.brandColor]: brand })}>
              {
                value && typeof value === 'object' ? (
                  <Message text={value} name="paymentNew/Bill/Row/value" dataTestId="billRowValue" />
                ) : (
                  <span dangerouslySetInnerHTML={{ __html: _value }} data-testid="billRowValue" />
                )
              }
            </div>
          )
        }
      </div>
    </div>
  )
}

const messageType = PropTypes.oneOfType([
  PropTypes.shape(intlMessageShape),
  PropTypes.string,
])

BillRow.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  label: messageType,
  note: messageType,
  value: messageType,
  brand: PropTypes.bool,
  isFetching: PropTypes.bool,
}


export default BillRow
